// KLiving project catalogue — Bhubaneswar, Odisha
// Premium construction & development company. Placeholder photography until real KLiving photos are provided.

export const COMPANY = {
    name: "KLiving",
    tagline: "Curating iconic lifestyles",
    description:
        "KLiving is a premium construction and development company specialising in luxury residential, commercial, and modern infrastructure projects. We combine innovative design, high-quality materials, and expert craftsmanship to deliver elegant, durable, and future-ready spaces. Our focus is on excellence, transparency, timely delivery, and customer satisfaction — creating properties that reflect sophistication, comfort, and long-term value. From concept to completion, KLiving transforms visions into landmark developments with world-class construction standards.",
    short:
        "A premium construction and development company crafting luxury residential, commercial, and modern infrastructure across Odisha and East India.",
    address: {
        line1: "MGM Heights, Plot no. 140/9957",
        line2: "K Living — 3rd floor, Kalinga Nagar",
        city: "Bhubaneswar",
        district: "Khurdha",
        pin: "751003",
        state: "Odisha",
        plusCode: "7Q77+QPR Bhubaneswar",
        phone: "+91 674 000 0000",
        email: "hello@kliving.co",
    },
};

export const projects = [
    {
        slug: "the-verdant-manor",
        name: "The Verdant Manor",
        tagline: "Six residences. One quiet hillside.",
        location: "Patia, Bhubaneswar",
        status: "ongoing",
        type: "Boutique Villas",
        units: "6 villas · 5,400 sqft",
        year: "2026",
        cover: "https://images.unsplash.com/photo-1544984243-ec57ea16fe25?ixlib=rb-4.1.0&q=85",
        gallery: [
            "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=1600&auto=format&fit=crop",
        ],
        summary:
            "A slow-lived enclave of six villas terraced along a private slope. Board-formed concrete meets local Odisha laterite, softened by mature raintrees and a shared reflection pool.",
    },
    {
        slug: "kalinga-heights",
        name: "Kalinga Heights",
        tagline: "Vertical living, horizontal calm.",
        location: "Kalinga Nagar, Bhubaneswar",
        status: "ongoing",
        type: "Sky Residences",
        units: "84 apartments · 3BHK–5BHK",
        year: "2027",
        cover: "https://images.unsplash.com/photo-1619218070141-bcfeb8b93074?ixlib=rb-4.1.0&q=85",
        gallery: [
            "https://images.unsplash.com/photo-1493809842364-78817add7ffb?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1487958449943-2429e8be8625?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1493397212122-2b85dda8106b?q=80&w=1600&auto=format&fit=crop",
        ],
        summary:
            "A twenty-eight-storey composition of alternating loggias and planted terraces. Each residence opens to the Kuakhai river on one side, and the temple skyline on the other.",
    },
    {
        slug: "the-atrium-house",
        name: "The Atrium House",
        tagline: "Light poured into stone.",
        location: "Nayapalli, Bhubaneswar",
        status: "completed",
        type: "Signature Residence",
        units: "1 residence · 12,800 sqft",
        year: "2024",
        cover: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?ixlib=rb-4.1.0&q=85",
        gallery: [
            "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=1600&auto=format&fit=crop",
        ],
        summary:
            "A single family house organised around a 40-foot central atrium clad in Kadapa stone. Delivered 2024. Featured in Architectural Digest India.",
    },
    {
        slug: "eastwood-commons",
        name: "Eastwood Commons",
        tagline: "Work, quietly.",
        location: "Chandaka Industrial Estate, Bhubaneswar",
        status: "completed",
        type: "Grade-A Commercial",
        units: "180,000 sqft · LEED Platinum",
        year: "2023",
        cover: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?ixlib=rb-4.1.0&q=85",
        gallery: [
            "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=1600&auto=format&fit=crop",
        ],
        summary:
            "A LEED Platinum grade-A office campus with a fully naturally ventilated lobby, deep-set brise-soleils and a rainwater-fed central court.",
    },
    {
        slug: "chilika-eleven",
        name: "Chilika Eleven",
        tagline: "Eleven acres. One horizon.",
        location: "Puri Road, near Chilika",
        status: "upcoming",
        type: "Weekend Villas",
        units: "11 villas · 6,200 sqft",
        year: "2028",
        cover: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1600&auto=format&fit=crop",
        gallery: [
            "https://images.unsplash.com/photo-1600566753104-685f4f24cb4d?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1600607687644-c7171b42498f?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1600566752355-35792bedcfea?q=80&w=1600&auto=format&fit=crop",
        ],
        summary:
            "A future community of eleven weekend villas on a coastal plateau overlooking Chilika lake. Groundbreaking Q2 2026.",
    },
    {
        slug: "the-marrow-tower",
        name: "The Marrow Tower",
        tagline: "A single tower. A single gesture.",
        location: "Jaydev Vihar, Bhubaneswar",
        status: "upcoming",
        type: "Sky Residences",
        units: "42 residences · full-floor",
        year: "2029",
        cover: "https://images.unsplash.com/photo-1493397212122-2b85dda8106b?q=80&w=1600&auto=format&fit=crop",
        gallery: [
            "https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1487958449943-2429e8be8625?q=80&w=1600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=1600&auto=format&fit=crop",
        ],
        summary:
            "Forty-two full-floor residences stacked around a single core, wrapped in a hand-cast concrete exoskeleton — our most ambitious composition to date.",
    },
];

// A single 360° equirectangular panorama used on the featured project.
// Replace with your actual 360° tour photograph when available.
export const PANORAMA_360 =
    "https://threejs.org/examples/textures/2294472375_24a3b8ef46_o.jpg";

export const testimonials = [
    {
        quote: "KLiving didn't sell us a home. They handed us a rhythm — light in the morning, water in the evening, silence at night.",
        author: "Ananya & Rohan Panda",
        project: "The Atrium House",
    },
    {
        quote: "The most patient developer I have worked with in 22 years. Every corner detailed, every joint considered.",
        author: "Ar. Kavya Mohapatra",
        project: "Eastwood Commons",
    },
    {
        quote: "We visited every unit in Bhubaneswar. Only KLiving felt like it had been designed by someone who intended to live there themselves.",
        author: "Vikram Sethi",
        project: "Kalinga Heights",
    },
    {
        quote: "The material palette — the concrete, the laterite, the ochre lime plaster — is a masterclass in restraint.",
        author: "Design Anthology · 2024",
        project: "Press",
    },
];

export const journal = [
    {
        slug: "on-slowness",
        chapter: "01",
        title: "On slowness, and why we take three years to build what others take one.",
        date: "Nov 2025",
        readTime: "6 min",
        cover: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?q=80&w=1600&auto=format&fit=crop",
    },
    {
        slug: "material-notes",
        chapter: "02",
        title: "Material notes: the case for hand-cast concrete in a machine-cast century.",
        date: "Sep 2025",
        readTime: "8 min",
        cover: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "living-with-monsoon",
        chapter: "03",
        title: "Living with the Odisha monsoon — how we designed Chilika Eleven's roofs.",
        date: "Jul 2025",
        readTime: "5 min",
        cover: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?q=80&w=1600&auto=format&fit=crop",
    },
];

export const careers = [
    { title: "Senior Architect — Residential", location: "Bhubaneswar", type: "Full-time" },
    { title: "Landscape Designer", location: "Bhubaneswar", type: "Full-time" },
    { title: "Project Manager — Commercial", location: "Bhubaneswar", type: "Full-time" },
    { title: "Interior Stylist (Contract)", location: "Remote / Site Visits", type: "Contract" },
    { title: "Site Engineer — Structural", location: "Bhubaneswar", type: "Full-time" },
];

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_luxury-developments-2/artifacts/cvs7gdzd_kliving.png";
